import type { QuoteDetailsData } from 'state/quotes/details/details.model';
import type { AppState } from 'state/state.model';

export function getAddonManagementFormQuoteDetails(state: AppState, formId: string): QuoteDetailsData | undefined {
  const lastQuoteId = state.addonManagementForm?.infos[formId].lastQuoteId;
  return state.addonManagementForm?.quoteDetails[lastQuoteId];
}
